import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import OrganisationInvitation from '../organisationInvitation';
import {translateToLocale} from '../../translations';

function SubcontractorAddView(props) {
  const [organisation, currentLocale, user] = useSelector(state => [
    state.organisation,
    state.i18n.locale,
    state.user
  ]);

  function translateInvitationMessage(language = currentLocale) {
    return props.reinvitedOrganisation ?
      translateToLocale(language, 'subcontractor.invite.reinviteDefaultMessage', {organisationName: organisation.fullName, userName: user.fullName}) :
      translateToLocale(language, 'subcontractor.invite.defaultMessage', {organisationName: organisation.fullName, userName: user.fullName});
  }

  return (
    <OrganisationInvitation
      externalInvitationOnNoDepositor
      title="subcontractor"
      onCancel={props.onClose}
      onSelectInternalInvitation={props.onSelectInternalInvitation}
      onExternalInvitation={props.onExternalInvitation}
      onTranslateInvitationMessage={translateInvitationMessage}
      reinvitedOrganisation={props.reinvitedOrganisation}
    />
  );
}

SubcontractorAddView.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSelectInternalInvitation: PropTypes.func.isRequired,
  onExternalInvitation: PropTypes.func.isRequired,
  reinvitedOrganisation: PropTypes.object
};

export default SubcontractorAddView;
